export default "__VITE_ASSET__9Oy_Bk4A__"